/* @flow */
import * as React from 'react';

import {Observable} from 'rxjs';

import {formatRelativeTimestamp} from './format-relative-timestamp';
import {type RelativeTimestampFormat, RELATIVE_TIMESTAMP_FORMATS} from './types';

type Props = {|
    datetime: ?number,
    // Note: 'toNow' is probably not what you want. (https://github.com/moment/moment/issues/2751#issuecomment-159903998)
    // `hourHybrid` will show relative time with 1 hour, then calendar time
    format?: RelativeTimestampFormat,
    children: ({formattedTimestamp: ?string}) => React.Node,
    hideAgoString?: boolean,
    lowercase?: boolean,
    customSuffix?: string,
|};

// Emit a tick once a minute, since we don't really update more often then that.
// But this guarantees we only have a single timer for all mounted timestamps.
const TIMER = Observable.interval(60000);

export function RelativeTimestampTimer(props: Props) {
    const forceUpdate = React.useState(0)[1];

    React.useEffect(
        function subscribeToTimer() {
            const subscription = TIMER.subscribe(function onTick() {
                forceUpdate(function increment(x) {
                    return x + 1;
                });
            });

            return function cleanup() {
                subscription.unsubscribe();
            };
        },
        [forceUpdate]
    );

    const formattedTimestamp = formatRelativeTimestamp({
        datetime: props.datetime,
        format: props.format || RELATIVE_TIMESTAMP_FORMATS.FROM_NOW,
        hideAgoString: props.hideAgoString,
        lowercase: props.lowercase,
        customSuffix: props.customSuffix,
    });

    return props.children({
        formattedTimestamp: formattedTimestamp,
    });
}
